<template>
  <svg class="base-svg-icon" :width="sWidth" :height="sHeight" :viewBox="sViewBox"  xmlns="http://www.w3.org/2000/svg" aria-hidden="true" v-html="svgDom"></svg>
</template>

<script>
// 想修改渐变颜色请查看已经使用的svg图标，写法如下
// var(--stopColor1,currentColor)
export default {
  name: "SVGIcon",
  props: {
    name: String,
  },
  data() {
    return {
      svgid: "",
      svgDom: "",
      sWidth:"0",
      sHeight:"0",
      sViewBox:"0 0 0 0",
    };
  },
  async created() {
    const svg = await import(`@/static/svg/${this.name}.svg`);
    this.svgid = svg.default.replace(/[/.]/g, "");
    const res = await fetch(svg.default).then((response) => response.text())
    const domInstance = new window.DOMParser().parseFromString(res, "text/xml");
    const domEle=domInstance.documentElement
    this.sWidth=domEle.getAttribute("width")
    this.sHeight=domEle.getAttribute("height")
    this.sViewBox=domEle.getAttribute("viewBox")||this.sViewBox
    this.svgDom = domEle.innerHTML;
  },
  
};
</script>

<style lang="less" scoped>
.base-svg-icon {
  height: 1em;
  width: 1em;
  overflow: hidden;
  fill: currentColor;
}
</style> 